import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import "./Notification.css";
import { useAuth } from "../../AuthContext";
import instance, { apiEncryptRequest, currencyReturn, decryptData } from "../../Api";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader";
import { FaSearch } from "react-icons/fa";

// ── Module-level helper ───────────────────────────────────────────────────────
const isMobileDevice = () => window.matchMedia("(max-width: 800px)").matches;

// ── Notification row — shared between Latest and Archive lists ────────────────
const NotiRow = ({ item, activeButton, appCurrency, smuser, onInvoice, onArchive, showCheckbox, showArchiveBtn, isMobile }) => (
  <div className="table-row-noti" style={isMobile ? undefined : { marginBottom:"15px" }}>
    <div className="bar" />
    <div className="message">
      <div className="title">{item.title}</div>
      {activeButton === 1 && item.remarks !== null && (
        <div className="desc">Description : {item.remarks}</div>
      )}
      {activeButton !== 1 && item.UserIP !== null && (
        <div className="desc">USER LOGIN IP : {item.UserIP}</div>
      )}
      {item.machineID !== null && (
        <div className="desc">Machine ID : {item.machineID}</div>
      )}
      {item.order_id !== null && (
        <div className="desc" style={isMobile ? { maxHeight:"none" } : undefined} onClick={() => onInvoice(item)}>
          Payment ID :{" "}
          <button style={{ color:"rgb(3,81,137)", border:"none", backgroundColor:"transparent", fontWeight:"600" }}>
            {item.order_id}
          </button>
        </div>
      )}
      {item.price !== null && (
        <div className="desc">
          Amount:{appCurrency && smuser && currencyReturn({ price:item.price, symbol:smuser.prefer_currency, rates:appCurrency })}
        </div>
      )}
    </div>
    <div className="datetime">{item.created_at}</div>
    {showArchiveBtn && onArchive && (
      <div className="archive-noti" onClick={() => onArchive(item.id)}>
        <a><img src="/images/admin/17-Notification/archive.png" title="Move to Archive" /></a>
      </div>
    )}
    {showCheckbox && (
      <input type="checkbox" checked readOnly style={{ marginRight:"25px", width:"28px", backgroundColor:"035189" }} />
    )}
  </div>
);

// ── Archive row (mobile) — different layout (image + datetime-arc-mobile) ────
const ArchiveRowMobile = ({ item, searchText }) => (
  <div className="table-row-noti">
    <div className="bar" />
    <div>
      {item.image !== "" ? (
        <img src={`/uploads/${item.image}`} style={{ width:"35px", height:"35px" }} />
      ) : (
        <div className="desc" style={{ fontSize:"14px" }}>No image found</div>
      )}
    </div>
    <div className="datetime-arc-mobile">
      <div className="message">
        <div className="title" style={{ color:"#035189", fontWeight:"500" }}>{item.title}</div>
        <div className="desc">{item.description}</div>
      </div>
    </div>
    <div className="datetime-arc-mobile">{item.created_at}</div>
  </div>
);

// ── Latest/Archive toggle ─────────────────────────────────────────────────────
const LatestArchiveToggle = ({ isLatest, setIsLatest, isMobile }) => {
  const size   = isMobile ? 60  : 100;
  const fSize  = isMobile ? 12  : 17;
  const mTop   = isMobile ? 20  : 15;
  const cntW   = isMobile ? 120 : 200;
  const cntL   = isMobile ? "130%" : "170%";
  return (
    <div style={{ position:"absolute", zIndex:"1", top:"0rem", width:`${cntW}px`, height:"60px", backgroundColor:"transparent", left:cntL }}>
      <div onClick={() => setIsLatest(false)} style={{ borderRadius:"12px", borderStartStartRadius:"0px", borderBottomLeftRadius:"0px", position:"absolute", zIndex:"1", top:"0rem", width:`${size}px`, height:"60px", left:`${size}px`, backgroundColor: isLatest?"#f1ddc8":"#e97730" }}>
        <p style={{ textAlign:"center", fontWeight:"700", fontSize:`${fSize}px`, marginTop:`${mTop}px`, color: isLatest?"#e97730":"white" }}>Archive</p>
      </div>
      <div onClick={() => setIsLatest(true)} style={{ borderRadius:"12px", borderStartEndRadius:"0px", borderBottomRightRadius:"0px", position:"absolute", zIndex:"1", top:"0rem", width:`${size}px`, height:"60px", backgroundColor: isLatest?"#e97730":"#f1ddc8" }}>
        <p style={{ textAlign:"center", fontWeight:"700", fontSize:`${fSize}px`, marginTop:`${mTop}px`, color: isLatest?"white":"#e97730" }}>Latest</p>
      </div>
    </div>
  );
};

// ── Search box ────────────────────────────────────────────────────────────────
const SearchBox = ({ searchText, onChange, isMobile }) => (
  <div style={{ marginLeft: isMobile?"4rem":undefined, marginTop: isMobile?"40px":undefined, display:"flex", alignItems:"center", width:"300px", height:"40px", padding:"0 12px", borderRadius:"20px", backgroundColor:"#f8f9fa", boxShadow:"0px 1px 3px rgba(0,0,0,0.2)", border:"2px solid #7890a1" }}>
    <FaSearch style={{ fontSize:"18px", color:"#9aa0a6", marginRight:"8px" }} />
    <input type="text" placeholder="Search..." value={searchText} onChange={onChange}
      style={{ flex:1, border:"none", outline:"none", fontSize:"16px", color:"black" }} />
  </div>
);

// ── Filter tab buttons — same set on mobile + web ─────────────────────────────
const FilterButtons = ({ btnClass, activeButton, adminNoti, vmNoti, billNoti, paymentNoti, allNotificationNative, allNotificationCloud, smuser, isLoginByParentUser, isLatest, isAllSelected, filteredNotifications, setActiveButton, setAllNotification, setFilteredNotifications, handleSelectAll, handleDeselectAll, onArchiveAll }) => {
  const allList = smuser.platform_status == 0 ? allNotificationNative : allNotificationCloud;
  const bg = (id) => ({ background: activeButton === id ? "#035189" : "#f47c20" });

  return (
    <div className="buttons-container" style={{ padding:"15px", marginTop: btnClass==="list-btns-mobile"?"50px":undefined }}>
      {(isLoginByParentUser==1 || btnClass==="list-btns-mobile") && (
        <Button className={btnClass} style={bg(1)} onClick={() => { setActiveButton(1); setAllNotification(adminNoti); setFilteredNotifications(adminNoti); }}>
          Admin Notif. ({adminNoti?.length ?? 0})
        </Button>
      )}
      <Button className={btnClass} style={bg(2)} onClick={() => { setActiveButton(2); setAllNotification(vmNoti); setFilteredNotifications(vmNoti); }}>
        VM Notif. ({vmNoti?.length ?? 0})
      </Button>
      {isLoginByParentUser==1 && (
        <Button className={btnClass} style={bg(3)} onClick={() => { setActiveButton(3); setAllNotification(billNoti); setFilteredNotifications(billNoti); }}>
          Billing Notif. ({billNoti?.length ?? 0})
        </Button>
      )}
      {isLoginByParentUser==1 && (
        <Button className={btnClass} style={bg(4)} onClick={() => { setActiveButton(4); setAllNotification(paymentNoti); setFilteredNotifications(paymentNoti); }}>
          Payment Notif. ({paymentNoti?.length ?? 0})
        </Button>
      )}
      <Button className={btnClass} style={bg(5)} onClick={() => { setActiveButton(5); setAllNotification(allList); setFilteredNotifications(allList); }}>
        All Notif. ({smuser.platform_status==0 ? allNotificationNative.length : 0})
      </Button>
      {isLoginByParentUser==1 && filteredNotifications.length>0 && isLatest && (
        <Button className={btnClass} style={{ background:"#f47c20" }} onClick={isAllSelected ? handleDeselectAll : handleSelectAll}>
          {isAllSelected ? "Unselect All" : "Select All"}
        </Button>
      )}
      {isLoginByParentUser==1 && activeButton===6 && filteredNotifications.length>0 && isLatest && isAllSelected && (
        <Button className={btnClass} style={{ background:"#035189" }} onClick={onArchiveAll}>
          Apply Archive
        </Button>
      )}
    </div>
  );
};

// ── Shared search filter for notifications ────────────────────────────────────
const searchMatch = (item, text) => {
  const t = text.toLowerCase();
  return (
    item.title?.toLowerCase().includes(t) ||
    item.UserIP?.toLowerCase().includes(t) ||
    item.machineID?.toLowerCase().includes(t) ||
    item.remarks?.toLowerCase().includes(t)
  );
};

// ── Main component ────────────────────────────────────────────────────────────
const Notification = () => {
  const navigate = useNavigate();
  const { smuser, appCurrency, isLoginByParentUser } = useAuth();

  const [isMobile, setIsMobile]     = useState(isMobileDevice);
  const [loading,  setLoading]      = useState(false);
  const [isLatest, setIsLatest]     = useState(true);
  const [activeButton, setActiveButton] = useState(5);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate]   = useState("");
  const [endDate,   setEndDate]     = useState("");

  const [allNotification,       setAllNotification]       = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [allNotificationCloud,  setAllNotificationCloud]  = useState([]);
  const [allNotificationNative, setAllNotificationNative] = useState([]);
  const [allnotiArchive,        setAllNotiArchive]        = useState([]);
  const [adminNoti,   setadminNoti]   = useState([]);
  const [vmNoti,      setVmNoti]      = useState([]);
  const [billNoti,    setBillNoti]    = useState([]);
  const [paymentNoti, setPaymentNoti] = useState([]);
  const [selectedAllId, setSelectAllId] = useState([]);

  // Fix: original had [isMobile] — GetNotification() re-fired on every resize
  useEffect(() => {
    window.scrollTo(0, 0);
    GetNotification();
    const handleResize = () => setIsMobile(isMobileDevice());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── API calls ──────────────────────────────────────────────────────────────
  const GetNotification = async () => {
    setLoading(true);
    try {
      const res   = await instance.post("/notification", { user_id: smuser.id });
      const data  = res.data;
      const arch  = data.allnotificationarchive;
      const native = data.allnotificationnative;
      const cloud  = data.allnotificationcloud;

      setAllNotiArchive(arch);
      setAllNotificationNative(native);
      setAllNotificationCloud(cloud);

      // Both branches do the same operations — just pick the right source list
      const src = smuser.platform_status === 0 ? native : cloud;
      setadminNoti(src.filter((i) => [20].includes(i.use_history_type)));
      setVmNoti(src.filter((i)    => [8, 7, 6].includes(i.use_history_type)));
      setBillNoti(src.filter((i)  => [11, 12].includes(i.use_history_type)));
      setPaymentNoti(src.filter((i) => [9, 10].includes(i.use_history_type)));
      setAllNotification(src);
      setFilteredNotifications(src);
      setSelectAllId(smuser.platform_status === 0 ? src.map((n) => n.id) : cloud.id);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const ArchiveCall = async (notifiID) => {
    setLoading(true);
    try {
      const enc = await apiEncryptRequest({ user_id: smuser.id, notification_id: notifiID });
      await instance.post("/notificationarchive", enc);
      GetNotification();
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  // Preserved — defined but not called from UI
  const getVoice = async () => {
    try { await instance.post("/invoiceview", { user_id: smuser.id, id: 7 }); } catch (e) { console.error(e); }
  };

  const changeCurrency = (value) => {}; // preserved

  // ── Helpers ────────────────────────────────────────────────────────────────
  const handleViewInvoice = (data) => navigate("/invoice", { state:{ billData:{ id:data.paymnet_id, orderid:data.order_id } } });
  const handleSelectAll   = () => { setActiveButton(6); setIsAllSelected(true); };
  const handleDeselectAll = () => { setActiveButton(null); setIsAllSelected(false); };
  const filterByDate      = () => {
    setFilteredNotifications(allNotification.filter((item) => {
      const d = new Date(item.created_at); d.setHours(0,0,0,0);
      const s = new Date(startDate);       s.setHours(0,0,0,0);
      const e = new Date(endDate);         e.setHours(0,0,0,0);
      return d >= s && d <= e;
    }));
  };

  // Shared props for FilterButtons
  const filterBtnProps = { activeButton, adminNoti, vmNoti, billNoti, paymentNoti, allNotificationNative, allNotificationCloud, smuser, isLoginByParentUser, isLatest, isAllSelected, filteredNotifications, setActiveButton, setAllNotification, setFilteredNotifications, handleSelectAll, handleDeselectAll, onArchiveAll: () => { setActiveButton(6); ArchiveCall(selectedAllId); } };

  // Shared props for NotiRow
  const notiRowProps = { activeButton, appCurrency, smuser, onInvoice: handleViewInvoice };

  // ── RENDER ────────────────────────────────────────────────────────────────
  return (
    <div style={{ width:"100%", minHeight:"65rem", position:"relative", backgroundImage:"url(./main-bg.jpg)", backgroundSize:"cover", backgroundRepeat:"round", backgroundBlendMode:"overlay" }}>
      {loading && <div className="loading-overlay" style={{ zIndex:"9999999999999999" }}><Loader isLoading={loading} /></div>}

      {isMobile ? (
        /* ── MOBILE ── */
        <div style={{ height:"50rem" }}>
          <div className="heading-dotted-machine">Notification <span /></div>
          <div className="billing-table-cont">
            <div className="billing-search" style={{ position:"relative", left:"20px", width:"60%", height:"15rem" }}>
              <div className="search-form">
                <div className="input-container-notif"><input type="date" name="from" className="input-signup" placeholder="From" /></div>
                <div className="input-container-notif"><input type="date" name="to" className="input-signup" placeholder="To" /></div>
                <input type="hidden" id="getval" value="All" />
                <div className="button-fields">
                  <div className="button-cont" style={{ marginTop:"-11px" }}>
                    <input type="submit" name="submit" value="Submit" className="input-submit new-btn" />
                  </div>
                </div>
                <SearchBox searchText={searchText} onChange={(e) => setSearchText(e.target.value)} isMobile />
                <LatestArchiveToggle isLatest={isLatest} setIsLatest={setIsLatest} isMobile />
              </div>
              <img src="/images/admin/09-Billing-Table/blue-bg.svg" className="bg-imagee mobile" alt="Background" />
            </div>

            <div className="tab-buttons-cont" />
            {isLatest && <FilterButtons btnClass="list-btns-mobile" {...filterBtnProps} />}

            {isLatest ? (
              <div className="notification-cont">
                {allNotification.filter((i) => searchMatch(i, searchText)).map((item, idx) => (
                  <NotiRow key={idx} item={item} {...notiRowProps} onArchive={null} showArchiveBtn={false} showCheckbox={false} isMobile />
                ))}
              </div>
            ) : (
              <div className="notification-cont" style={{ marginTop:"60px" }}>
                {allnotiArchive.filter((i) => searchMatch(i, searchText)).map((item, idx) => (
                  <ArchiveRowMobile key={idx} item={item} />
                ))}
              </div>
            )}
          </div>
        </div>
      ) : (
        /* ── WEB ── */
        <div className="features-page-solution" style={{ height:"100%", padding:"5rem" }}>
          <div className="heading-dotted-machine">Notification <span /></div>
          <div className="features-section-solution">
            <Row>
              <div className="col-md-1" />
              <div className="col-md-10">
                <div className="billing-table-cont">
                  <div className="billing-search" style={{ width: isLoginByParentUser==1?"50%":"40%", height:"4rem" }}>
                    <div className="search-form">
                      <div className="input-container-notif"><input type="date" name="from" className="input-signup" placeholder="From" onChange={(e) => setStartDate(e.target.value)} /></div>
                      <div className="input-container-notif"><input type="date" name="to" className="input-signup" placeholder="To" onChange={(e) => setEndDate(e.target.value)} /></div>
                      <input type="hidden" id="getval" value="All" />
                      <div className="button-fields">
                        <div className="button-cont" style={{ marginTop:"-11px" }}>
                          <input type="submit" name="submit" value="Submit" className="input-submit new-btn" onClick={filterByDate} />
                        </div>
                      </div>
                    </div>
                    <SearchBox searchText={searchText} onChange={(e) => setSearchText(e.target.value)} />
                    <img src="/images/admin/09-Billing-Table/blue-bg.svg" className="bg-imagee desktop" alt="Background" />
                    <img src="/images/admin/09-Billing-Table/blue-bg.svg" className="bg-imagee mobile" alt="Background" />
                    {isLoginByParentUser==1 && <LatestArchiveToggle isLatest={isLatest} setIsLatest={setIsLatest} />}
                  </div>

                  <div className="tab-buttons-cont" />
                  {isLatest && <FilterButtons btnClass="list-btns-web" {...filterBtnProps} />}

                  {isLatest ? (
                    <div className="notification-cont">
                      {filteredNotifications.filter((i) => searchMatch(i, searchText)).map((item, idx) => (
                        <NotiRow key={idx} item={item} {...notiRowProps}
                          onArchive={isLoginByParentUser==1 ? ArchiveCall : null}
                          showArchiveBtn={isLoginByParentUser==1}
                          showCheckbox={activeButton===6} />
                      ))}
                    </div>
                  ) : (
                    <div className="notification-cont">
                      {allnotiArchive.filter((i) => searchMatch(i, searchText)).map((item, idx) => (
                        <NotiRow key={idx} item={item} {...notiRowProps} onArchive={null} showArchiveBtn={false} showCheckbox={false} />
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-1" />
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notification;